import React, { useState, useEffect } from "react";
import MaskedInput from 'react-text-mask';
import '../HomePage/Quotes.css';
import '../HomePage/HomeInsurance.css';
import "react-datepicker/dist/react-datepicker.css";
import CustomDatePicker from "./UtilityComponents/CustomDatePicker";
import { CityStateByPinCode } from "../CommonMethods/CityStateByPinCode";
import { FilterData } from "./FilterData";
import { useSharedDataContext } from "../components/SharedDataContext";
import { apiURL } from "../index";
import { CentralCall } from "../CommonMethods/CentralCall";

const ProposalForm = ({ stateData, BtnValue, KYCMaster, onProposalSubmit }) => {

    const [Error, setError] = useState({});
    const [touchedFields, setTouchedFields] = useState({});
    const [isValid, setValid] = useState(false);
    const [nomineeRelationList, setNomineeRelationList] = useState([]);
    const [proposerDetails, setProposerDetails] = useState({
        Name: "",
        Gender: "Male",
        Email: "",
        MobileNo: "",
        PersonType: "1",
        DOB: "",
        IdentificationType: "",
        IdentificationNo:"",
        GSTNumber:""
    });
    const [addressDetails, setAddressDetails] = useState({
        Address: "",
        HouseNo: "",
        Pincode: "",
        Location:""
    });

    const [nomineeDetails, setNomineeDetails] = useState({
        NomineeName: "",
        RelationName:"",
        NomineeRelation:""
    });

    const { sharedData, setSharedData } = useSharedDataContext();

    useEffect(() => {
        if (sharedData?.proposalFormData) {
            const {
                PersonType,
                Name,
                Email,
                MobileNo,
                DOB,
                Gender,
                GSTNumber,
                IdentificationType,
                IdentificationNo,
                Address,
                HouseNo,
                Pincode,
                NomineeName,
                NomineeRelation,
            } = sharedData?.proposalFormData;

            setProposerDetails(prev => ({ ...prev, Name, Gender, Email, MobileNo, PersonType, DOB, IdentificationType, IdentificationNo, GSTNumber }));
            setAddressDetails({ ...addressDetails, Address, HouseNo, Pincode });
            setNomineeDetails({ ...nomineeDetails, NomineeName, NomineeRelation });
        } else {
            setAddressDetails({ ...addressDetails, Pincode: stateData.pinCode });
            setProposerDetails({ ...proposerDetails, MobileNo: stateData.MobileNo })
        }

    }, [sharedData.proposerFormData]);

/*    const nomineeRelationOpt = [
        //{ value: "disabled", label: "Select nominee relation" },
        { value: "Father", label: "Father" },
        { value: "Mother", label: "Mother" },
        { value: "Spouse", label: "Spouse" },
        { value: "Grand Father", label: "Grand Father" },
        { value: "Grand Mother", label: "Grand Mother" },
        { value: "Son", label: "Son" },
        { value: "Daughter", label: "Daughter" },
        { value: "Brother", label: "Brother" },
        { value: "Sister", label: "Sister" },
        { value: "Grand Son", label: "Grand Son" },
        { value: "Grand Daughter", label: "Grand Daughter" },
        { value: "Others", label: "Other" }

    ]*/

    const getNomineeMaster = () => {
        const model = {
            URL: `${apiURL}api/central/GetMaster`,
            Req: {
                masterType: "nomineerelation",
                insurerID: stateData.insurerID
            },
            IsPost: true
        }

        CentralCall(model).then(Res => {
            setNomineeRelationList(Res.data ?? []);
        }).catch(error => console.log({ error }));


    }

    const validateEmail = (email) => {
        var re = /^(([^<>()\[\]\\.,;#:`~\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const today = new Date();
    const maxDate = new Date(
        today.getFullYear() - (proposerDetails.PersonType ==1 ? 18 :0),
        today.getMonth(),
        today.getDate()
    );

    const minDate = new Date(
        today.getFullYear() - 100,
        today.getMonth(),
        today.getDate()
    );


    useEffect(() => {
        setProposerDetails(prev => ({ ...prev, DOB: maxDate }));
        getNomineeMaster();
    }, []);

    useEffect(() => {
        const selectedIdType = KYCMaster.find(item => item.name.toLowerCase() === "pan");
        if (selectedIdType) {
            setProposerDetails(prev => ({ ...prev, IdentificationType: selectedIdType.code }));
        }
    }, [KYCMaster]);


    useEffect(() => {
        async function fetchPinCodeDetails() {
            if (addressDetails?.Pincode?.length === 6) {
                try {
                    const { data } = await CityStateByPinCode(addressDetails?.Pincode);
                    if (data.statusCode === 200) {
                        setAddressDetails(prev=>({ ...prev, Location: `${data.response.cityName}, ${data.response.stateName}` }));
                    }
                } catch (error) {
                    console.error("Error fetching pin code details:", error);
                }
            } else {
                setAddressDetails(prev=>({ ...prev, Location: "" }));
            }
        }
        fetchPinCodeDetails();
    }, [addressDetails.Pincode]);

    useEffect(() => {
        validateForm();

    }, [
        proposerDetails.DOB,
        proposerDetails.Name,
        proposerDetails.MobileNo,
        proposerDetails.Email
        ,proposerDetails.IdentificationType,
        proposerDetails.IdentificationNo,
        addressDetails.Address,
        addressDetails.Pincode,
        nomineeDetails.NomineeName,
        nomineeDetails.NomineeRelation,
        proposerDetails.GSTNumber,
        proposerDetails.PersonType
    ]);

    const validateForm = () => {
        const { DOB, Name, Email, MobileNo, PersonType, GSTNumber, IdentificationType, IdentificationNo, Gender } = proposerDetails;
        const { Address, HouseNo, Pincode } = addressDetails;
        const { NomineeName, NomineeRelation, RelationName } = nomineeDetails;

        let error = {};
        let goto = true;

        if (touchedFields.DOB && (DOB === "" || DOB === "Date OF Birth")) {
            error["DOB"] = "Select Date Of Birth";
            goto = false;
        }
        if (touchedFields.Name && (Name.trim() === "")) {
            error["Name"] = "Enter Your Name";
            goto = false;
        }
        if (touchedFields.IdentificationType  && !IdentificationType) {
            error["IdentificationType"] = "Select Any IdentificationType";
            goto = false;
        }
        if (touchedFields.IdentificationNo && !IdentificationNo.trim()) {
            error["IdentificationNo"] = "Enter Identification No.";
            goto = false;
        }
        if (touchedFields.Email && Email === "") {
            error["Email"] = "Enter Email";
            goto = false;
        }
        else if (touchedFields.Email && !validateEmail(Email)) {
            error["Email"] = "Enter Valid Email";
            goto = false;
        }
        else if (touchedFields.Email && Email.includes("..")) {
            error["Email"] = "Enter Valid Email";
            goto = false;
        }
        else if (touchedFields.Email && ((Email.slice(0, 1) === ".") || (Email.slice(0, 1) === "-"))) {
            error["Email"] = "Enter Valid Email";
            goto = false;
        }
        if (touchedFields.Pincode && Pincode === "") {
            error["Pincode"] = "Enter Pin Code";
            goto = false;
        }
        else if (touchedFields.Pincode && Pincode.length !== 6) {
            error["Pincode"] = "Enter Valid Pin Code";
            goto = false;
        }
        if (touchedFields.Address && Address.trim() === "") {
            error["Address"] = "Enter Your Address";
            goto = false;
        } else if (touchedFields.Address && Address.trim().length <= 3) {
            error["Address"] = "Enter Valid Address";
            goto = false;
        }
        if (touchedFields.MobileNo && MobileNo.trim() === "") {
            error["MobileNo"] = "Enter Your Mobile No.";
            goto = false;
        }
        else if (touchedFields.MobileNo && MobileNo.length !== 10) {
            error["MobileNo"] = "Enter Valid Mobile No.";
            goto = false;
        }
        if (touchedFields.NomineeName && !NomineeName.trim()) {
            error["NomineeName"] = "Enter Your Nominee Name.";
            goto = false;
        }
        if (touchedFields.NomineeRelation &&  !RelationName) {
            error['NomineeRelation'] = "Select Nominee Relation.";
            goto = false;
        }
        if (touchedFields.GSTNumber && PersonType==2 && GSTNumber.trim() == "") {
            error['GSTNumber'] = "Enter GST Number";
            goto = false;
        }
        setValid(goto);
        setError(error);
    }

    const submitForm = (e) => {
        e.preventDefault();
        const { DOB, Name, Email, MobileNo, PersonType, GSTNumber, IdentificationType, IdentificationNo, Gender } = proposerDetails;
        const { Address, HouseNo, Pincode } = addressDetails;
        const { NomineeName, NomineeRelation } = nomineeDetails;
        if (isValid) {

            const model = {
                PersonType,
                Name,
                Email,
                MobileNo,
                DOB,
                Gender,
                GSTNumber,
                IdentificationType,
                IdentificationNo,
                Address,
                HouseNo,
                Pincode,
                NomineeName,
                NomineeRelation: NomineeRelation ? NomineeRelation :null,
            }

            setSharedData({ ...sharedData, proposalFormData: model });
            onProposalSubmit(model);
        }


    }
   
    const handleProposerDetail = (e) => {
        const { name, value } = e.target;

        setProposerDetails({ ...proposerDetails, [name]: value });
        setTouchedFields(prev => ({ ...prev, [name]: true }));
    }
    const handleAddressDetail = (e) => {
        const { name, value } = e.target;
        setAddressDetails({ ...addressDetails, [name]: value });
        setTouchedFields(prev => ({ ...prev, [name]: true }));
    }

    const checkDOB = (e) => {
        const today = new Date();
        const maxDate = new Date(
            today.getFullYear() -  18,
            today.getMonth(),
            today.getDate()
        );

        if (!e.target.checked && (maxDate < proposerDetails.DOB)) {
            setProposerDetails(prev => ({ ...prev, DOB: maxDate }));
        }
    }

    console.log({ nomineeDetails });

    return (
        <>
            <div className="Lowest_Rate proposal_userinput">
                <form className="form_detail">
                    <p><h4>Few More Details</h4> <span><input type="checkbox" checked={proposerDetails.PersonType === "2"} name="PersonType" onChange={(e) => { setProposerDetails({ ...proposerDetails, PersonType: e.target.checked ? "2" : "1" }); checkDOB(e)  }} /> Buyer is Corporate</span></p>
                    <div className="proposal_form">
                        <div className="user_detail proposal_detail">
                            <MaskedInput mask={[
                                    /[a-zA-Z]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                    /[a-zA-Z\s]/,
                                ]}
                                className="User_name"
                                guide={false}
                                id="Name"
                                required
                                placeholder=""
                                type="text"
                                value={proposerDetails.Name}
                                name="Name"
                                onChange={handleProposerDetail} />
                            <label htmlFor="Name" > {proposerDetails.PersonType === "1" ? "Full " : "Company "}Name</label>
                            <span className="error_msg">{Error["Name"]}</span>
                        </div>
                        {proposerDetails.PersonType === "2" && <div className="user_detail proposal_detail">
                            <input
                                className="User_name"
                                guide={false}
                                id="Name"
                                required
                                placeholder=""
                                type="text"
                                value={proposerDetails.GSTNumber}
                                name="GSTNumber"
                                onChange={handleProposerDetail} />
                            <label htmlFor="Name">GST Number</label>
                            <span className="error_msg">{Error["GSTNumber"]}</span>
                        </div>}
                        {proposerDetails.PersonType === "1" && <div className="mt-4 proposal_detail">
                            <span className="property_type">Gender</span>
                            <span className="property_type">
                                <input
                                    type="radio"
                                    value="Male"
                                    name="Gender"
                                    className=""
                                    onChange={handleProposerDetail}
                                    checked={proposerDetails.Gender === "Male"} />
                                Male
                            </span>
                            <span className="property_type">
                                <input type="radio"
                                    value="Female"
                                    name="Gender"
                                    className=""
                                    onChange={handleProposerDetail}
                                    checked={proposerDetails.Gender === "Female"} />
                                Female
                            </span>
                        </div>}
                    </div>
                    <div className="proposal_form">
                        <div className="user_detail proposal_detail date_margin">
                            <span className="Date_head">Date of {proposerDetails.PersonType === "1" ? "Birth" : "Incorporation"} </span>
                            <CustomDatePicker
                                id="DOB"
                                setDOB={(date) => setProposerDetails({...proposerDetails, DOB:date})}
                                minDate={minDate}
                                maxDate={maxDate}
                                RegDate={proposerDetails.DOB}
                            />
                            <span className="error_msg">{Error["DOB"]}</span>
                        </div>
                        <div className="user_detail proposal_detail">
                            <input type="text" id="Email" value={proposerDetails.Email} name="Email" onChange={handleProposerDetail} required />
                            <label htmlFor="Email">Email Address</label>
                            <span className="error_msg">{Error["Email"]}</span>
                        </div>
                    </div>

                    <div className="proposal_form">
                        <div className="user_detail proposal_detail select_margin">
                            <p className="identificationType mb-0">Identification Type</p>
                            <select id="identificationType" className="" name="IdentificationType" value={proposerDetails.IdentificationType} onChange={(e) => setProposerDetails({ ...proposerDetails, IdentificationType: e.target.value })}>
                                <option value="">--Select--</option>
                                {KYCMaster?.map(r => <option value={r.code} >{r.name}</option>)}
                            </select>
                            <span className="error_msg error_msg2">{Error["IdentificationType"]}</span>
                        </div>
                        <div className="user_detail proposal_detail">
                            <input className="text-uppercase" type="text" id="identificationNumber" name="IdentificationNo" defaultValue={proposerDetails.IdentificationNo} onChange={(e) => setProposerDetails({ ...proposerDetails, IdentificationNo: e.target.value })} />
                            <label htmlFor="identificationNumber">Identification Number</label>
                            <span className="error_msg">{Error["IdentificationNo"]}</span>
                        </div>
                    </div>
                    <div className="proposal_form">
                        <div className="user_detail proposal_detail">
                            <input type="text" className="User_name" placeholder=" " id="Address" name="Address" value={addressDetails.Address} onChange={handleAddressDetail}  />
                            <label htmlFor="Address">Address</label>
                            <span className="error_msg">{Error["Address"]}</span>
                        </div>
                        <div className="user_detail proposal_detail">
                            <input type="text" className="User_name" placeholder=" " id="Address" name="HouseNo" value={addressDetails.HouseNo} onChange={handleAddressDetail}  />
                            <label htmlFor="Address">House Number</label>
                            <span className="error_msg">{Error["HouseNo"]}</span>
                        </div>
                    </div>
                    <div className="proposal_form">
                        <div className="user_detail proposal_detail pin_margin">
                            <MaskedInput
                                mask={[
                                    /[1-9]/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                ]}
                                guide={false}
                                className=""
                                type="text"
                                name="Pincode"
                                id="Pin"
                                placeholder=""
                                value={addressDetails.Pincode}
                                maxLength="6"
                                onChange={handleAddressDetail}
                                 />
                            <label htmlFor="Pin">PIN Code</label>
                            <span className="city_stateName">{addressDetails?.Location}</span>
                            <span className="error_msg">{Error["Pincode"]}</span>
                        </div>
                        <div className="user_detail proposal_detail mobileTop_margin">
                            <MaskedInput
                                mask={[
                                    /[6-9]/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                ]}
                                guide={false}
                                className="User_name"
                                type="text"
                                id="MobileNumber"
                                name="MobileNo"
                                placeholder=""
                                value={proposerDetails.MobileNo}
                                maxLength="10"
                                onChange={handleProposerDetail}
                                />
                            <label htmlFor="MobileNumber">Mobile Number</label>
                            <span className="error_msg">{Error["MobileNo"]}</span>
                        </div>
                    </div>
                    <div className="proposal_form ">
                        <div className="user_detail dropdown proposal_detail filter_margin">
                            <span className="DropDown_label">Select Nominee Relation</span>
                            <FilterData
                                ArrayList={nomineeRelationList?? []}
                                FilterKey={"name"}
                                onSelect={(data) => { setNomineeDetails({ ...nomineeDetails, NomineeRelation: data.code, RelationName:data.name }); setTouchedFields(prev => ({ ...prev, NomineeRelation: true })) } }
                                DefaultTitle={nomineeDetails.RelationName ? nomineeDetails.RelationName : "Select Nominee Relation"}
                                ListNameKey={"name"}
                                className="filter_dropdwon"
                            />
                            <span className="error_msg mt-4">{Error["NomineeRelation"]}</span>
                        </div>
                        <div className="user_detail proposal_detail mobileTop_margin2">
                            <MaskedInput mask={[
                                /[a-zA-Z]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                                /[a-zA-Z\s]/,
                            ]}
                                guide={false} type="text" className="User_name" placeholder=" " id="Nomineefullname" name="NomineeName" value={nomineeDetails?.NomineeName} onChange={(e) => { setNomineeDetails({ ...nomineeDetails, NomineeName: e.target.value }); setTouchedFields(prev => ({...prev, NomineeName:true })) }} />
                            <label htmlFor="Nomineefullname">Nominee Full Name</label>
                            <span className="error_msg">{Error["NomineeName"]}</span>
                        </div>
                    </div>

                    <div className="view_quotes">
                        <button type="submit" className="SMCLarg1" onClick={submitForm} disabled={!proposerDetails.Gender || !proposerDetails.IdentificationType || !proposerDetails.IdentificationNo.trim() || !addressDetails.Pincode.trim() || !proposerDetails.Email.trim() || !proposerDetails.DOB || !proposerDetails.Name.trim() || !addressDetails.Address.trim() || !nomineeDetails.NomineeName.trim() || !nomineeDetails.RelationName.trim() || !addressDetails.HouseNo.trim() || (proposerDetails.PersonType == 2 && !proposerDetails.GSTNumber.trim())}>
                            {BtnValue}
                            <i className="fa fa-chevron-right"></i>
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}
export default ProposalForm;
